<template>
  <Wrapper>
    <Loading v-if="isLoading"></Loading>
    <BadRequest :lang="lang" v-if="isBadRequest"></BadRequest>
    <InternalServerError
      v-if="isCreateServerError"
      :lang="lang"
    ></InternalServerError>
    <main
      v-if="!isLoading && !isBadRequest && !isCreateServerError"
      class="main"
    >
      <!-- パンくずリスト -->
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}` }"
            class="breadcrumb-trail__list--item__link"
          >
            TOP
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}result` }"
            class="breadcrumb-trail__list--item__link"
          >
            Results
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{
              path: `/${langPath}ranking`,
              query: {
                event: this.$route.query.event,
                page: this.$route.query.page,
              },
            }"
            class="breadcrumb-trail__list--item__link"
          >
            {{ dataEventRanking.name }}
          </router-link>
        </li>
      </ol>
      <!-- タイトル -->
      <section class="main__title">
        <h1
          class="main__title--name"
          :style="`border-left: solid 15px ${dataEventRanking.text.event_color_code};`"
        >
          {{ dataEventRanking.name }}
        </h1>
        <figure class="main__title--figure">
          <img
            :src="`https://tmf-virtualrun.jp/images/${dataEventRanking.text.image_file_name}`"
            alt=""
            height="140"
          />
        </figure>
      </section>
      <!-- 説明（Oliveから入稿） -->
      <p
        class="ranking-description"
        v-html="dataEventRanking.text.ranking_description"
      ></p>
      <!-- タブ（2021/08東京マラソンバーチャル専用） -->
      <ul class="course-tab-list">
        <li
          v-for="(multiEventId, index) in dataEventRanking.text
            .multi_event_id_list"
          :key="index"
          @click="onTabClick(index, multiEventId)"
          class="course-tab-list__item"
          :class="{ 'tab-active': isTabActive === index }"
          >{{ dataEventRanking.text.event_multi_name[index] }}</li
        >
      </ul>
      <!-- タブ切り替えで更新されるDOM -->
      <Loading v-if="!isUpdateTab"></Loading>
      <template v-else>
        <!-- 概要テーブル -->
        <EventInfo
          :data-event-ranking="dataEventRanking"
          :data-event-summary="dataEventSummary"
        ></EventInfo>
        <hr class="width-line" />
        <!-- ユーザー検索 -->
        <UserSearch
          class="section"
          :lang="lang"
          :lang-path="langPath"
        ></UserSearch>
        <!-- 検索条件エリア -->
        <!-- 居住地エリア選択あり 企業大会以外 && 束ね対応 [日本 area=99, country=都道府県コード]-->
        <ForeignRefinedSearch
          v-if="!$route.path.includes('company') && isForeignCountry"
          class="section"
          :is-loading-ranking="isLoadingRanking"
          :is-not-found="isNotFound"
          :is-server-error="isServerError"
          :data-ranking="dataRanking"
          :data-event-summary="dataEventSummary"
          @type-narrowing-down="typeNarrowingDown"
          @initial-ranking="initialRanking"
        ></ForeignRefinedSearch>
        <!-- 居住地都道府県選択のみ 企業大会 && 旧イベント [area=都道府県コード]-->
        <RefinedSearch
          v-else
          class="section"
          :is-loading-ranking="isLoadingRanking"
          :is-not-found="isNotFound"
          :is-server-error="isServerError"
          :data-ranking="dataRanking"
          :data-event-summary="dataEventSummary"
          @type-narrowing-down="typeNarrowingDown"
          @initial-ranking="initialRanking"
        ></RefinedSearch>
        <!-- ランキング -->
        <section class="section">
          <v-pagination
            v-if="!isLoadingRanking && !isNotFound && !isServerError"
            v-model="$page.current"
            v-bind:length="$page.total"
            v-bind:total-visible="$page.visible"
            color="#0093e6"
            class="rank-pagination"
          ></v-pagination>
          <Status
            :is-loading-ranking="isLoadingRanking"
            :is-not-found="isNotFound"
            :is-server-error="isServerError"
            :is-initial-ranking-data="isInitialRankingData"
            :event-status="eventStatus"
            :count-total-runner="countTotalRunner"
            @initial-ranking="initialRanking"
          ></Status>
          <!-- ページング  -->
          <!-- ランキングリスト（1位~100位） -->
          <RankingList
            v-if="!isLoadingRanking && !isNotFound && !isServerError"
            :lang="lang"
            :lang-path="langPath"
            :ranking="Ranking"
            :data-event-ranking="dataEventRanking"
            :data-event-summary="dataEventSummary"
            :data-ranking="dataRanking"
            :event-status="eventStatus"
            :is-foreign-country="isForeignCountry"
            :nass-event-id="nassEventId"
          ></RankingList>
          <!-- ページング  -->
          <v-pagination
            v-if="!isLoadingRanking && !isNotFound && !isServerError"
            v-model="$page.current"
            v-bind:length="$page.total"
            v-bind:total-visible="$page.visible"
            color="#0093e6"
            class="rank-pagination"
          ></v-pagination>
        </section>
      </template>
    </main>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../components/pc/Wrapper";
import Loading from "../../../components/pc/Loading";
import BadRequest from "../../../components/common/status/BadRequest";
import InternalServerError from "../../../components/common/status/InternalServerError";
import EventInfo from "../../../components/pc/ranking/EventInfo";
import UserSearch from "../../../components/pc/ranking/UserSearch";
import Status from "../../../components/pc/ranking/Status";
import ForeignRefinedSearch from "../../../components/pc/ranking/ForeignRefinedSearch";
import RefinedSearch from "../../../components/pc/ranking/RefinedSearch";
import RankingList from "../../../components/pc/ranking/RankingList";
import Ranking from "../../../assets/constants/ranking/ranking";
import { RepositoryFactory } from "../../../api/RepositoryFactory";
const RankingRepository = RepositoryFactory.get("ranking");

export default {
  data() {
    return {
      isLoading: true,
      isLoadingRanking: true,
      isBadRequest: false,
      isCreateServerError: false,
      isUpdateTab: true,
      isTabActive: 0,
      isForeignCountry: false,
      isNotFound: false,
      isServerError: false,
      isInitialRankingData: false,
      selectGender: "",
      selectAge: "",
      selectArea: "",
      selectCountry: "",
      dataEventRanking: null,
      dataEventSummary: null,
      dataRanking: null,
      nassEventId: "",
      eventStatus: "",
      countTotalRunner: 0,
      offset: 0,
    };
  },
  async created() {
    // イベントIDをsessionストレージに入れる
    sessionStorage.setItem("nassEventId", this.$route.query.event);
    // イベント情報取得
    const EventRepository = RepositoryFactory.get("event");
    const params = {
      event: sessionStorage.getItem("nassEventId"),
      lang: this.lang,
    };
    try {
      const response = await EventRepository.getEventRanking(params);
      this.dataEventRanking = response.data;
      this.isForeignCountry = response.data.text.new_event_api_flag;
      this.nassEventId = sessionStorage.getItem("nassEventId");
      // イベントサマリ取得
      await this.fetchEventSummary();
    } catch (e) {
      if (e.response.status === 400) {
        this.isBadRequest = true;
        return;
      }
      this.isCreateServerError = true;
    } finally {
      this.isLoading = false;
    }

    // ランキング取得
    await this.initialRanking();
  },
  methods: {
    /**
     * タブ押下時の処理
     */
    onTabClick: async function (tabNumber, multiEventId) {
      this.isUpdateTab = false;
      this.isTabActive = tabNumber;
      this.nassEventId = multiEventId; // 束ね対応の前提
      sessionStorage.setItem("nassEventId", multiEventId);
      await this.fetchEventSummary();
      await this.initialRanking();
      // 絞り込み初期化
      this.selectGender = "";
      this.selectAge = "";
      this.selectArea = "";
      this.selectCountry = "";

      // 条件初期化
      this.initialConditions();

      // 2ページ目以降を表示中の場合は1ページ目に戻す
      if (this.$page.current === 1) {
        await this.fetchRanking(false);
      } else {
        this.$page.current = 1;
      }

      // 「〇〇人見つかりました」はinitialの時は表示しない
      this.isInitialRankingData = false;

      this.isUpdateTab = true;
    },

    /**
     * イベントサマリ取得
     */
    fetchEventSummary: async function () {
      const params = {
        event: sessionStorage.getItem("nassEventId"),
        lang: this.lang,
      };
      const EventRepository = RepositoryFactory.get("event");
      const response = await EventRepository.getEventSummary(params);
      this.dataEventSummary = response.data;
    },

    /**
     * 初回検索
     */
    initialRanking: async function () {
      // 絞り込み初期化
      this.selectGender = "";
      this.selectAge = "";
      this.selectArea = "";
      this.selectCountry = "";

      // 条件初期化
      this.initialConditions();
      await this.fetchRanking(false);

      // 「〇〇人見つかりました」はinitialの時は表示しない
      this.isInitialRankingData = false;
    },

    /**
     * ランキング絞り込み検索
     */
    typeNarrowingDown: async function (
      selectGender,
      selectAge,
      selectArea,
      selectCountry,
      _selectBranch,
      _selectDepartment,
      _selectAffiliation
    ) {
      // 条件初期化
      this.selectArea = selectArea;
      this.selectCountry = selectCountry;
      this.selectGender = selectGender;
      this.selectAge = selectAge;
      await this.initialConditions();
      await this.fetchRanking(true);
    },

    /**
     * コンポーネントの状態とデータの初期化
     */
    initialConditions: function () {
      this.isLoadingRanking = true;
      this.isNotFound = false;
      this.isServerError = false;
      this.dataRanking = null;
      this.countTotalRunner = 0;
    },

    /**
     * 通信部分共通
     */
    fetchRanking: async function (isOffsetInitial) {
      // 年齢分ける
      const list = this.selectAge ? this.selectAge.split(",") : [];
      const param = {
        nass_event: this.nassEventId,
        gender: this.selectGender,
        min_age: list[0] || "",
        max_age: list[1] || "",
        area: this.selectArea,
        country: this.selectCountry,
        offset: isOffsetInitial ? 0 : (this.$route.query.page - 1) * 100,
        limit: 100,
        size: 100,
        lang: this.lang,
      };

      try {
        const response = await RankingRepository.getRanking(param);
        this.dataRanking = response.data;

        // 総件数（paging用と表示用）
        this.$page.rows = response.data.metadata.total_count;
        this.countTotalRunner = response.data.metadata.total_count;

        // イベントステータス（'0'か'100'）
        this.eventStatus = response.data.metadata.status;

        // 「〇〇人見つかりました」はinitialの時は表示しない
        this.isInitialRankingData = true;

        // ページ数をセット
        this.$page.current = isOffsetInitial ? 1 : this.$route.query.page;

        // ページング
        this.offset = isOffsetInitial ? 0 : (this.$page.current - 1) * 100;
      } catch (e) {
        if (e.response.status === 404) {
          this.$page.rows = 0;
          this.isNotFound = true;
        } else {
          this.isServerError = true;
        }
      } finally {
        this.isLoadingRanking = false;
      }
    },
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    Wrapper,
    Loading,
    BadRequest,
    InternalServerError,
    EventInfo,
    UserSearch,
    Status,
    ForeignRefinedSearch,
    RefinedSearch,
    RankingList,
  },
  watch: {
    "$page.current": function (newNumber) {
      this.$router.push(
        {
          name: this.name,
          query: {
            event: this.$route.query.event,
            page: newNumber,
          },
        },
        () => {
          this.fetchRanking(false);
        }
      );
    },
  },
  name: "Ranking",
};
</script>

<style scoped>
.main {
  &__title {
    margin: 70px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &--name {
      margin: 0 34px 0 0;
      padding: 0 0 0 25px;
      border-left: solid 15px #0093e6;
      line-height: 1.3;
      font-size: 50px;
      font-weight: 900;
    }

    &--figure {
      padding: 14px 10px;
      border: solid 1px #eee;
    }
  }

  .width-line {
    margin: 60px 0 0 0;
    width: 100%;
    border-top: solid 1px #000;
  }

  .ranking-description {
    margin: 60px 0 0 0;
    line-height: 1.5;
    font-size: 16px;
    font-weight: 500;
  }

  .course-tab-list {
    display: flex;
    margin: 70px 0 0 0;
    border-bottom: solid 1px #000;
    &__item {
      flex: 1;
      padding: 12px;
      font-size: 30px;
      font-weight: bold;
      color: #333;
      background-color: #eee;
      cursor: pointer;
      &:not(:first-of-type) {
        margin: 0 0 0 16px;
      }
    }
    .tab-active {
      margin: 0 0 -1px 16px;
      border-top: solid 1px #000;
      border-right: solid 1px #000;
      border-left: solid 1px #000;
      background-color: #fff;
    }
  }

  .section {
    margin: 60px 0 0 0;
  }
  .rank-pagination {
    margin: 80px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pc/ranking/Ranking.vue